<!-- BaseExcelDown.vue (common) -->
<template tag="공통 엑셀 다운로드 컴포넌트">
  <v-row>
    <v-col> </v-col>
  </v-row>
</template>
<script setup lang="ts">
import { getCmmnCdOption } from "@/common/api/cmmn/CmmnApi";
import { excelDown, type ExcelHeader, type ExcelItem } from "@/common/types/ExcelTypes";
import type { CmmnCodeOptionType } from "@/common/types/cmmn/CmmnTypes";
import { i18n } from "@/common/plugins/global";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
const { $text } = i18n();

/* ------------------------------------------------------------
                          Expose
   ------------------------------------------------------------ */
/**
 * 엑셀 다운로드
 * @returns
 *
 */
defineExpose({
  /** 엑셀 다운로드 */
  onClickExcel: async (
    headers: ExcelHeader[],
    items: ExcelItem[],
    fileNm: string,
    type?: string
  ) => {
    excelDown(headers, items, fileNm, type);
  },
  /** 공통 코드 데이터 가져오기 (단일, 다중) */
  setExcelCmmnCdForm: async (cdArr: string | string[]) => {
    const cds = Array.isArray(cdArr) ? cdArr : [cdArr];
    const result = [];

    for (const cd of cds) {
      const cmmnList = await getCmmnCdOption({ upCdArr: [cd] });

      // 공통 코드 데이터를 code, name 형태로 변환하여 반환
      const cmmnData =
        cmmnList[cd]?.map((item: CmmnCodeOptionType) => ({
          label: item.label || "",
          value: item.value || "",
        })) || [];

      result.push({
        sheetName: $text("excel.cmmnCdSheetName") + " (" + cd + ")",
        headers: [
          { header: $text("name"), key: "label", width: 30 },
          { header: $text("excel.code"), key: "value", width: 15 },
        ],
        items: cmmnData,
      });
    }

    return result;
  },
});
</script>
